import { render } from "./ComplianceProfileTabs.vue?vue&type=template&id=273ea1b2"
import script from "./ComplianceProfileTabs.vue?vue&type=script&lang=js"
export * from "./ComplianceProfileTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__